<template>
	<svg
		:class="svgClass" data-animated-illustration viewBox="0 0 500 500">
		<g
			v-show="playing"
			:stroke-width="strokeWidth" fill="none" stroke-linecap="round"
			stroke-linejoin="round" stroke-miterlimit="10">
			<slot/>
		</g>
	</svg>
</template>
<script>
export default {
	data() {
		return {
			playing: false,
			played: false,
			paths: null,
		};
	},
	props: {
		color: {
			type: String,
			required: false,
		},
		strokeWidth: {
			type: Number,
			required: false,
			default() {
				return 1;
			},
		},
		duration: {
			type: Number,
			required: false,
			default() {
				return 2000;
			},
		},
	},
	computed: {
		svgClass() {
			return {
				play: this.played,
			};
		},
	},
	methods: {
		setPathOffset(el) {
			el.style["stroke-dashoffset"] = el.dataset.pathLength;
		},
		zeroPathOffset(el) {
			el.style["stroke-dashoffset"] = 0;
		},
		play() {
			this.playing = true;
			_.each(this.paths, (path) => {
				this.zeroPathOffset(path);
			});
			this.played = true;
		},
	},
	mounted() {
		this.paths = this.$el.querySelectorAll("[data-animated-illustration] *:not(g)");

		setTimeout(() => {
			_.each(this.paths, function (path) {
				let length = path.getTotalLength();
				path.setAttribute("data-path-length", length);
				path.style["stroke-dasharray"] = length;
				path.style["transition-duration"] = this.duration + "ms";
				this.setPathOffset(path);
			}.bind(this));
		}, 100);

		setTimeout(() => {
			this.play();
		}, 350);
	},
};
</script>
<style>
[data-animated-illustration].play *:not(g) {
	transition: all 2s cubic-bezier(.42, 0, .58, 1);
}
</style>
